// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectLogo_container_x_NW-","logoImage":"ProjectLogo_logoImage_141Kr","logoEmpty":"ProjectLogo_logoEmpty_2e-n9"};